import { throwError as observableThrowError, Observable, of } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { AuthService } from './auth.service';

export interface HttpResponseBase<T> {
  IsSuccess: boolean;
  Message: string;
  Content?: T;
}

@Injectable()
export class HttpService {
  private BASE_URL: string = environment.apiBaseURL;

  private OPOGOPLATFORM_BASE_URL: string = environment.opogoPlatformApiUrl;

  private OPOGOPLATFORM_URLS: string[] = [
    '/client/getclientbyloggeduser',
    '/api/candidate-search/query',
    '/api/candidate-search/suggestions',
    '/api/candidate-search/profile-views',
    '/api/insights/context',
    '/api/insights/terms',
    '/api/insights/filter-options',
    '/api/insights/query',
    '/api/insights/query/batch',
    '/api/insights/booked-days',
    '/api/insights/booked-days/export'
  ]

  constructor(private auth: AuthService, private http: HttpClient) {
  }

  get(url: string, options?: any): Observable<any> {
    url = this.getAbsoluteUrl(url);
    return this.http.get(url, options);
  }

  getNoLoggedIn(url: string, options?: any): Observable<any> {
    url = this.getAbsoluteUrl(url);
    return this.http.get(url, options);
  }

  post(url: string, body: any, options?: any): Observable<any> {
    if (this.auth.isLoggedIn()) {
      url = this.getAbsoluteUrl(url);
      return this.http.post(url, body, options);
    }
    return of(null);
  }

  postNoLoggedIn(url: string, body: any, options?: any): Observable<any> {
    url = this.getAbsoluteUrl(url);
    return this.http.post(url, body, options);
  }

  postToken(body: any, options?: any): Observable<any> {
    let baseUrl = `${this.BASE_URL}`.endsWith('/api') ? `${this.BASE_URL}`.slice(0, -4) : `${this.BASE_URL}`;
    let url: string = `${baseUrl}/token`;
    return this.http.post(url, body, options);
  }

  put(url: string, body: any, options?: any): Observable<any> {
    if (this.auth.isLoggedIn()) {
      url = this.getAbsoluteUrl(url);
      return this.http.put(url, body, options);
    }
    return of(null);
  }

  delete(url: string, options?: any): Observable<any> {
    if (this.auth.isLoggedIn()) {
      url = this.getAbsoluteUrl(url);
      return this.http.delete(url, options);
    }
    return of(null);
  }

  request(method: string, url: string, options?: any): Observable<any> {
    if (this.auth.isLoggedIn()) {
      url = this.getAbsoluteUrl(url);
      return this.http.request(method, url, options);
    }
    return of(null);
  }

  private getAbsoluteUrl(url: string): string {
    const baseUrl = this.getBaseUrl(url);

    if (baseUrl.toLowerCase().endsWith('/api') && url.toLowerCase().startsWith('/api/')) {
      return `${baseUrl}${url.substring(4)}`;
    }

    return `${baseUrl}${url}`;
  }

  private getBaseUrl(url: string) {
    if (this.OPOGOPLATFORM_URLS.includes(url.toLowerCase())) {
      return this.OPOGOPLATFORM_BASE_URL;
    }

    return this.BASE_URL;
  }
}
